module.exports = __webpack_public_path__ + "img/37-dj.15ac049f.svg";